/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SimplifiedChildQuestion } from './SimplifiedChildQuestion';
export type UpdateIndividualQuestion = {
  readonly id?: number;
  options?: Array<string>;
  delete_children?: boolean;
  children_questions?: Array<SimplifiedChildQuestion>;
  question_type: UpdateIndividualQuestion.question_type;
  description?: string | null;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  questionnaire?: number | null;
  parent_question?: number | null;
  company_information_request_status?: number | null;
  company_question?: number | null;
};
export namespace UpdateIndividualQuestion {
  export enum question_type {
    TEXT = 'text',
    DATE = 'date',
    DROPDOWN = 'dropdown',
    MULTIPLE = 'multiple',
  }
}
